import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {didMountEffect} from 'front-onceforall-core/dist/utils/customHooks';

import ShareComplianceQuestion from './ShareComplianceQuestion';
import NbOfClientsQuestion from './NbOfClientsQuestion';

function PlanSelectionQuestionContainer(props) {
  const organisation = useSelector(state => state.organisation);
  const [shareCompliance, setShareCompliance] = React.useState();
  const [nbOfClients, setNbOfClients] = React.useState();

  function shouldShowNbOfClientsQuestion() {
    return shareCompliance && organisation?.country === COUNTRY.FRANCE && organisation?.organisationType !== 'BRANCH';
  }

  didMountEffect(() => {
    if (shareCompliance !== undefined) {
      if (!shareCompliance || !shouldShowNbOfClientsQuestion()) {
        setNbOfClients();
        props.submit({
          shareCompliance
        });
      }
    }
  }, [shareCompliance]);

  didMountEffect(() => {
    if (nbOfClients) {
      props.submit({
        shareCompliance: true,
        nbOfClients
      });
    }
  }, [nbOfClients]);

  function displayNbOfClientsQuestion() {
    /**
     * Don't display question if organisation doesn't whish to share compliance
     * Don't display question if organisation country is not FRANCE
     */
    if (!shouldShowNbOfClientsQuestion()) {
      return null;
    }

    return (
      <NbOfClientsQuestion
        answer={nbOfClients}
        setAnswer={setNbOfClients}
      />
    );
  }

  return (
    <div className='mt-4 mb-5'>
      <ShareComplianceQuestion
        answer={shareCompliance}
        setAnswer={setShareCompliance}
      />
      {displayNbOfClientsQuestion()}
    </div>
  );
}

PlanSelectionQuestionContainer.propTypes = {
  submit: PropTypes.func.isRequired
};

export default PlanSelectionQuestionContainer;
